/**
 * Global error reporter - catches uncaught errors and reports them to the backend.
 * Import and call initErrorReporter() once in index.js or App.js.
 */
import api from "./api";

let initialized = false;

export function initErrorReporter() {
    if (initialized) return;
    initialized = true;

    const report = (category, message, detail = "", url = "") => {
        try {
            api.post("/errors/report", {
                category,
                message: String(message).substring(0, 500),
                url: url || window.location.href,
                detail: String(detail).substring(0, 2000),
                component: "",
                user_agent: navigator.userAgent,
            }).catch(() => {});
        } catch { /* silent */ }
    };

    // Catch unhandled JS errors
    window.addEventListener("error", (e) => {
        if (e.message === "ResizeObserver loop completed with undelivered notifications.") return;
        report("frontend_error", e.message, `${e.filename}:${e.lineno}:${e.colno}\n${e.error?.stack || ""}`, window.location.href);
    });

    // Catch unhandled promise rejections
    window.addEventListener("unhandledrejection", (e) => {
        const msg = e.reason?.message || String(e.reason).substring(0, 200);
        if (msg.includes("401") || msg.includes("Network Error")) return;
        report("frontend_error", `Unhandled Promise: ${msg}`, e.reason?.stack || "", window.location.href);
    });
}
